module.exports = __webpack_public_path__ + "static/media/zingworks_logo.912593b5.svg";